import React from "react";
import {Badge, Card, OverlayTrigger, Tooltip} from "react-bootstrap";
import {STATUS_ORDER, statusDescription, statusLabel, statusVariant} from "./zustaendigkeitStatus.js";
import {formatEuroWhole} from "./format.js";

/**
 * Kennzahlen-Kacheln je Status - anklickbar als Filter (Mehrfachauswahl,
 * Bauauftrag Punkt 4). Ein Klick nimmt den Status in die aktive Auswahl auf
 * bzw. entfernt ihn wieder. Die angezeigten Zahlen gelten VOR dem
 * Status-Filter (Person/Suche wirken schon) - so bleiben die übrigen
 * Kacheln als Umschalter nutzbar, auch wenn schon ein Status gewählt ist.
 * Eine Kachel mit Anzahl 0 verschwindet vollständig (Regel leere
 * Dashboard-Bausteine) - sonst stünde z. B. dauerhaft "Ehemalig 0" da. Jede
 * Kachel erklärt ihren Status über einen Tooltip am Knopf selbst (Hover und
 * Tastaturfokus).
 */
export default function ZustaendigkeitStatusTiles({counts, selected, onToggle}) {
    if (!counts || counts.length === 0) {
        return null;
    }

    const byStatus = Object.fromEntries(counts.map((c) => [c.status, c]));
    const sichtbareStatus = STATUS_ORDER.filter((status) => (byStatus[status]?.anzahl || 0) > 0);

    if (sichtbareStatus.length === 0) {
        return null;
    }

    return (
        <div className="d-flex flex-wrap gap-2 mb-3">
            {sichtbareStatus.map((status) => {
                const eintrag = byStatus[status];
                const aktiv = selected.includes(status);
                const beschreibung = statusDescription(status);

                const tile = (
                    <button
                        type="button"
                        onClick={() => onToggle(status)}
                        className="btn p-0 border-0 bg-transparent text-start"
                        aria-pressed={aktiv}
                    >
                        <Card className={`shadow-sm h-100 ${aktiv ? "border-primary border-2" : ""}`} style={{minWidth: 190}}>
                            <Card.Body className="py-2 px-3">
                                <div className="d-flex align-items-center justify-content-between gap-2 mb-1">
                                    <Badge bg={statusVariant(status)}>{statusLabel(status)}</Badge>
                                    <span className="fw-semibold">{eintrag.anzahl}</span>
                                </div>
                                <div className="small text-muted">{formatEuroWhole(eintrag.umsatz_laufend)} lfd. Jahr</div>
                            </Card.Body>
                        </Card>
                    </button>
                );

                if (!beschreibung) {
                    return <React.Fragment key={status}>{tile}</React.Fragment>;
                }

                return (
                    <OverlayTrigger key={status} placement="top" overlay={<Tooltip id={`va-zust-status-${status}`}>{beschreibung}</Tooltip>}>
                        {tile}
                    </OverlayTrigger>
                );
            })}
        </div>
    );
}
